<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import AudioChip from 'next/message/chips/Audio.vue';
import MessageMeta from '../MessageMeta.vue';
import { useMessageContext } from '../provider.js';
import { ORIENTATION } from '../constants';

const { attachments, orientation, sender } = useMessageContext();

const attachment = computed(() => {
  return attachments.value[0];
});

const isOutgoing = computed(() => orientation.value === ORIENTATION.RIGHT);

// O rosto de quem gravou, ao lado da onda. Sem foto, o player desenha as
// iniciais — nunca um círculo vazio.
const avatarUrl = computed(
  () => sender.value?.thumbnail || sender.value?.avatar_url || ''
);
const avatarNome = computed(() => sender.value?.name || '');
</script>

<template>
  <BaseBubble
    class="px-2 py-2"
    data-bubble-name="audio"
    hide-meta
    hide-reply-to
  >
    <AudioChip
      :attachment="attachment"
      :is-outgoing="isOutgoing"
      :avatar-url="avatarUrl"
      :avatar-nome="avatarNome"
      class="skip-context-menu"
    >
      <template #meta>
        <MessageMeta
          :class="isOutgoing ? 'text-white/60' : 'text-n-slate-11'"
        />
      </template>
    </AudioChip>
  </BaseBubble>
</template>
